import { MetricSelectScene } from '../MetricSelect/MetricSelectScene';

export function buildRelatedMetricsScene() {
  return new MetricSelectScene({});
}
